import * as localForage from 'localforage';
import { find, findIndex } from 'lodash';
import moment from 'moment';
import { EntityLastUpdateType } from '../../interface/LastUpdate';
import { GenericService } from '../../services/GenericService';

const gs = new GenericService();

export const getDocuments = (
  url: string,
  docName: EntityLastUpdateType,
  callback: (items: any[] | any) => void,
  noCache?: boolean
) => {
  if (noCache) {
    getDocs(docName, url, callback);
  } else {
    localForage
      .getItem(docName)
      .then(async (response: any) => {
        if (response) {
          const hasUpdate = await documentsHasUpdated(docName);
          if (hasUpdate) {
            callback(response);
            return;
          }
        }
        getDocs(docName, url, callback);
      })
      .catch(() => {
        callback([]);
        return;
      });
  }
};

const getDocs = (docName: string, url: string, callback: (items: any[] | any) => void) => {
  switch (docName) {
    case 'Company':
      get(url, docName, (item: any) => {
        callback(item);
        return;
      });
      break;
    case 'Commodity':
    case 'CountyState':
    case 'Terminal':
    case 'Driver':
    case 'PickUp':
    case 'DropOff':
      getAll(url, docName, (list: any[]) => {
        callback(list);
        return;
      });
  }
};

export const getAll = (url: string, docName: EntityLastUpdateType, callback: (items: any[]) => void) => {
  gs.getAll(url, {})
    .then((response: any) => {
      if (response?.data) {
        const data = response.data.map((value: any, index: number) => {
          return { ...value, ...{ _id: index } };
        });
        setItemForage(docName, data, callback);
      } else if (docName === 'Terminal') setItemForage(docName, [], callback);
    })
    .catch(() => {
      callback([]);
      return;
    });
};

export const setItemForage = (key: EntityLastUpdateType, value: any, callback?: (items: any[] | any) => void) => {
  localForage
    .setItem(key, value)
    .then(() => {
      setLastUpdateDocumentItem(key);
      callback?.(value);
    })
    .catch(() => {
      callback?.(null);
      return;
    });
};

export const get = (url: string, docName: EntityLastUpdateType, callback: (item: any) => void) => {
  gs.getAll(url, {})
    .then((response: any) => {
      if (response && response.data) {
        setItemForage(docName, response.data, callback);
      }
    })
    .catch(() => {
      callback([]);
      return;
    });
};

export const documentsHasUpdated = (docName: string): Promise<boolean> => {
  return getLastUpdateDocumentByName(docName)
    .then((res: any) => {
      if (res) {
        if (moment(new Date()).diff(res.date) < 1.8e6) {
          return Promise.resolve(true);
        }
      }
      return Promise.resolve(false);
    })
    .catch(() => Promise.resolve(false));
};

export const getLastUpdateDocumentByName = (docName: string): Promise<any> => {
  return localForage
    .getItem('lastUpdate')
    .then((response: any) => {
      if (response) {
        const item = find(response, (value: any) => value.name === docName);
        if (item) {
          return Promise.resolve(item);
        }
      }
      return Promise.resolve(null);
    })
    .catch(() => {
      return Promise.resolve(null);
    });
};

export const setLastUpdateDocumentItem = (docName: string) => {
  const item = { name: docName, date: moment().toISOString() };
  localForage.getItem('lastUpdate').then((res: any) => {
    const resp = res || [];
    const index = findIndex(resp, { name: docName });
    if (index !== -1) {
      resp[index] = item;
    } else {
      resp.push(item);
    }
    localForage.setItem('lastUpdate', resp);
  });
};
